/**
 * @fileOverview A very simple console logging module.
 *
 * @author matt.steitle@mapmyfitness.com
 * @returns {Object} window.console or object of empty functions mapped to console methods
 */

mmf_modules.define('console',[
    'utils/settings'
], function (
    mmf_settings
) {
    'use strict';

    var empty = function () {},

        logger = (function () {
            if (window.console && mmf_settings.debug) {
                return window.console;
            } else {
                return (
                    function () {
                        var obj = {}, i, len;
                        for (i = 0, len = arguments.length; i < len; i++) {
                            if (arguments.hasOwnProperty(i)) {
                                obj[arguments[i]] = empty;
                            }
                        }
                        return obj;
                    }('log',
                      'debug',
                      'info',
                      'warn',
                      'exception',
                      'assert',
                      'dir',
                      'dirxml',
                      'trace',
                      'group',
                      'groupEnd',
                      'groupCollapsed',
                      'profile',
                      'profileEnd',
                      'count',
                      'clear',
                      'time',
                      'timeEnd',
                      'timeStamp',
                      'table',
                      'error',
                      'memoryProfile',
                      'memoryProfileEnd'
                    )
                );
            }
        }());

    return logger;
});
